import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  SvgIcon,
  Typography,
  Stack,
  Divider,
  Tabs,
  Tab,
  Button,
  Menu,
  MenuItem
} from "@mui/material";
import { useAppDispatch } from "../../redux/store";
import { logout } from "../../redux/features/userSlice";
import Logo from '../../assets/ocesha_images/ocesha_logo.png';
import { toast } from "react-toastify";
import { removeCookie } from "utils/storageUtils";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { ReactComponent as LogoutIco } from '../../assets/ocesha_images/logout_ico.svg';
import { redirectAfterLogout } from "../../utils/logoutRedirect";


const pages = [
  {
    text: "Dashboard",
    link: "/dashboard",
  },
  {
    text: "Course Enrollments",
    link: "/enrollments",
  },
  {
    text: "Prompt Configurator",
    link: "/config/prompts",
  },
  {
    text: "Product Configurator",
    link: "/config/products",
  },

  /* {
    text: "SubscriberList",
    link: "/subscribelist",
  },

  {
    text: "Content Management",
    link: "/content/edit",
  },
  {
    text: "Price Configurator",
    link: "/config/prices",
  },

  {
    text: "API Configurator",
    link: "/config/api",
  }, */
  
];

const AdminHeader = () => {
  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const dispatch = useAppDispatch();


  const handleLogout = () => {
    localStorage.setItem("logged_in", "false");
    //console.log("loggedin:" + localStorage.getItem("logged_in"));
    dispatch(logout());
    var module = localStorage.getItem("module");

    toast.success("Logout success");
    localStorage.removeItem("payment");
    localStorage.removeItem("msg");
    localStorage.removeItem("complexity");
    localStorage.removeItem("module");
    localStorage.removeItem("subscription_level");
    localStorage.removeItem("free_plan");
    localStorage.removeItem('userRole');
    localStorage.removeItem('user_email');
    removeCookie('user_email');
    localStorage.clear();

    console.log("module111...." + module);
    if (module == process.env.REACT_APP_MAIN_PRODUCT_NAME)
      navigate("/Anycode_landing");
    else
      redirectAfterLogout();   //"https://ocesha.ai";

    // localStorage.removeItem("userRole");

  }

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div className="adminhead">
        <Box sx={{ padding: "5px 32px" }}>
          <Stack flexDirection="row" gap={'10px'} justifyContent="space-between" width="100%">
            <Stack flexDirection="row" gap="10px" alignItems="center">
              <Stack gap="8px" flexDirection="row">
                <a href={process.env.REACT_APP_LOGOUT_DOMAIN || "https://ocesha.ai"}><img src={Logo} style={{ width: '60px' }} /></a>
              </Stack>
              <Tabs
                onChange={(e: React.SyntheticEvent, newValue: number) =>
                  setValue(newValue)
                }
                value={value}
              >
                {pages.map((page, index) => (
                  <Tab
                    key={`admin_tab_${index}`}
                    label={page.text}
                    id={`admin-tab-${index}`}
                    sx={{
                      textTransform: "none",
                      "&.Mui-selected": { color: "#155bab" },
                      color: "#155bab",
                    }}
                    onClick={() => navigate(`/admin${page.link}`)}
                  />
                ))}
               {/*  {pages.length > 0 && (
                  <Tab
                    key={`admin_tab_0`}
                    label={pages[0].text}
                    id={`admin-tab-0`}
                    sx={{
                      textTransform: "none",
                      "&.Mui-selected": { color: "#155bab" },
                      color: "#155bab",
                    }}
                    onClick={() => navigate(`/admin${pages[0].link}`)}
                  />
                )} */}
              </Tabs>
            </Stack>
            {/* <Stack style={{ marginLeft: '40%' }}>
              <Button
                sx={{
                  background: "linear-gradient(270deg, #4BA5EB 0%, #0168B5 100%)",
                  marginLeft: 0,
                  color: "white",
                  paddingX: 2,
                  paddingY: 1
                }}
                onClick={handleLogout}
              >
                Logout
              </Button>
            </Stack> */}
            <Stack flexDirection="row" alignItems="center" gap="3px">
              {/* userImage ? <img src={userImage} style={{ width: '50px', height: '50px', borderRadius: '50%', objectFit: 'cover' }} alt="" /> : userDetails?.user_image ? <img src={userDetails?.user_image} style={{ width: '50px', height: '50px', borderRadius: '50%', objectFit: 'cover' }} alt="" /> : */ <AccountCircleIcon style={{ alignSelf: 'center' }} />}
              <div style={{ display: 'flex', alignItems: 'center', marginLeft: '-1%' }}>
                <KeyboardArrowDownIcon style={{ cursor: 'pointer' }} onClick={handleClick}/* onClick={() => handleViewDropdownClick()} */ />

                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  PaperProps={{
                    style: {
                      backgroundColor: '#fff',
                      color: '#000',
                      borderRadius: '5px',
                      minWidth: '214px',
                      boxShadow: 'none',
                      border: '1px solid #CACBCC',
                      top: '65px'
                    },
                  }}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                >
                  <MenuItem style={{ color: '#000' }} onClick={handleLogout}>
                    <LogoutIco fontSize="small" style={{ marginRight: '8px' }} />
                    Logout
                  </MenuItem>
                </Menu>
              </div>
            </Stack>
          </Stack>
        </Box>
        <Divider />
      </div>
      {/* <Divider /> */}
    </>
  );
};

export default AdminHeader;
